import { useState } from "react";
import { UserCheck, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { digits } from "@/lib/api";
import { norm } from "@/lib/mobile";

export function CustomerSearch({ customers, value, onChange }) {
  const [focus, setFocus] = useState(false);
  const s = norm(value.customer_name);
  const d = digits(value.customer_name);
  const hits = s.length >= 2 && !value.customer_id
    ? customers.filter((c) => c.active !== false && (norm(c.name).includes(s) || (d.length >= 3 && digits(c.phone || c.whatsapp).includes(d)))).slice(0, 6)
    : [];
  return (
    <div className="relative">
      <Input value={value.customer_name} onChange={(e) => onChange({ customer_id: null, customer_name: e.target.value })}
        onFocus={() => setFocus(true)} onBlur={() => setTimeout(() => setFocus(false), 150)}
        placeholder="Nome ou telefone do cliente" className="h-12 bg-white text-base" data-testid="m-new-customer-input" />
      {value.customer_id && (
        <p className="mt-1 flex items-center gap-1 text-xs font-semibold text-emerald-700" data-testid="m-new-customer-linked">
          <UserCheck className="h-4 w-4" />Cliente cadastrado
          <button type="button" onClick={() => onChange({ customer_id: null, customer_name: "" })} className="ml-1 text-slate-400" aria-label="Remover cliente" data-testid="m-new-customer-clear"><X className="h-4 w-4" /></button>
        </p>
      )}
      {focus && hits.length > 0 && (
        <ul className="absolute z-20 mt-1 w-full overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-slate-200" data-testid="m-customer-suggestions">
          {hits.map((c) => (
            <li key={c.id}>
              <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => { onChange({ customer_id: c.id, customer_name: c.name }); setFocus(false); }}
                className="flex w-full flex-col px-3 py-2.5 text-left hover:bg-[#e3f2fd]" data-testid={`m-customer-option-${c.id}`}>
                <span className="text-sm font-semibold">{c.name}</span>
                {(c.phone || c.whatsapp) && <span className="text-xs text-slate-500">{c.phone || c.whatsapp}</span>}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
